import { render, staticRenderFns } from "./ForcedLifeStageCompletion.vue?vue&type=template&id=44a75fae&scoped=true&"
import script from "./ForcedLifeStageCompletion.vue?vue&type=script&lang=js&"
export * from "./ForcedLifeStageCompletion.vue?vue&type=script&lang=js&"
import style0 from "./ForcedLifeStageCompletion.vue?vue&type=style&index=0&id=44a75fae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a75fae",
  null
  
)

export default component.exports